import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.partners || initialState;

const makeSelectPartnersList = () =>
  createSelector(select, subState => subState.partnersList);

const makeSelectUsersListByPartnerId = () =>
  createSelector(select, subState => subState.usersByPartnerId);

const makeSelectUsersListBeAdminPartner = () =>
  createSelector(select, subState => subState.usersBeAdminPartner);

const makeSelectPartner = () =>
  createSelector(select, subState => subState.partner);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);

const makeSelectPartnerCategoriesList = () =>
  createSelector(select, subState => subState.partnerCategories);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);
const makeSelectPartnersInventoryListById = () =>
  createSelector(select, subState => subState.partnersInventoryList);

export default select;
export {
  makeSelectPartnersList,
  makeSelectUsersListByPartnerId,
  makeSelectUsersListBeAdminPartner,
  makeSelectPartnersInventoryListById,
  makeSelectPartner,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectPartnerCategoriesList,
};
